import { LANGUAGES } from "./catalogView"

// The words of the catalog commands (sportya-api docs/tournament-feedback.md, „Editarea catalogului din CP”): what the Setup tab
// says while a change waits for its receipt, after it, and for each refusal code. The approved texts come from
// docs/design/tournament-feedback/README.md.

export const COMMANDS = "/admin/tournament-feedback/catalog-operations"
export const OPERATION = "tournament-feedback-catalog"
export const SAVED = "Saved. The change is in the change history and the activity logs."

// An item's id in the commands: the theme's code, or „theme.reason” for a reason.
export const itemIdOf = item => item?.type === "reason" ? `${item.themeCode}.${item.code}` : item?.code
// Stands for the item the Save's first command creates, whose code Accounts gives at save: a later command of the same Save (the
// English and Bulgarian written by hand on a server that does not translate) takes its id and revision from the previous receipt.
export const CREATED_ITEM = "@created"

// The revision a receipt gives the item, for the next command of the same Save.
export const revisionIn = (receipt, itemId) => {
  const items = Array.isArray(receipt?.items) ? receipt.items : []
  const revision = (items.find(item => itemIdOf(item) === itemId) || items[0])?.revision
  return Number.isSafeInteger(revision) ? revision : null
}

const languageName = language => (LANGUAGES.find(([key]) => key === language) || [])[1] || "translated"
const BLOCKERS = {
  pending: name => `the ${name} translation is in progress`,
  missing: name => `write the ${name} translation by hand`,
  manualRequired: name => `write the ${name} translation by hand`,
  tooLong: name => `the ${name} translation is too long; correct it by hand`,
}
const notReady = blockers => {
  const parts = (Array.isArray(blockers) ? blockers : []).map(({ language, status } = {}) => (BLOCKERS[status] || BLOCKERS.missing)(languageName(language)))
  return parts.length ? `Not ready: ${parts.join("; ")}.` : "Not ready: check its translations."
}

// What a refusal code means for the admin. `form` is true in the add and edit form, where the approved conflict text applies.
export function refusalText(code, details = {}, { form = false } = {}) {
  const limit = Number.isSafeInteger(details?.limit) ? details.limit : null
  switch (code) {
    case "FEEDBACK_CATALOG_ITEM_CHANGED":
    case "FEEDBACK_ITEM_STATUS_UNCHANGED":
    case "FEEDBACK_CATALOG_ITEM_NOT_FOUND":
      return form ? "This item changed since you opened it. Close the form and reload the page to see the current version."
        : "This item changed since the page loaded. The page now shows its current version; check it before trying again."
    case "FEEDBACK_ITEM_NOT_READY": return notReady(details?.blockers)
    case "FEEDBACK_ITEM_ANSWERED": return "Players already answered this item, so its texts can no longer change. To word it differently, deactivate it and add a new one."
    case "FEEDBACK_ACTIVE_THEMES_LIMIT": return `${limit ?? 5} of ${limit ?? 5} themes are active: deactivate a theme before activating another.`
    case "FEEDBACK_ACTIVE_REASONS_LIMIT": return `${limit ?? 8} of ${limit ?? 8} reasons are active in this theme: deactivate a reason before activating another.`
    case "FEEDBACK_CATALOG_NO_CHANGE": return "Nothing to save: this is the saved version."
    case "FEEDBACK_ORGANIZER_FIXED": return "The Organizer theme always stays first."
    case "INVALID_TRANSLATION_CONTENT":
    case "INVALID_TRANSLATION_LANGUAGE": return "Write every translated text, within its limit."
    case "INVALID_TRANSLATION_STATE": return "The automatic translation is no longer available for this text. Reload the page to see the current version."
    case "INVALID_FEEDBACK_CATALOG_OPERATION": return "The change was not accepted. Check the texts and the icon, then save again."
    case "SUPER_ADMIN_REQUIRED":
    case "SESSION_EXPIRED": return "Your session no longer has SuperAdmin access."
    case "OPERATION_PAYLOAD_CONFLICT": return "This request identifier belongs to a different change. Check the change history."
    case "UNCONFIRMED": return "The change has not been confirmed yet. Its result is being checked; Retry sends the same request."
    case "AWAITING": return "The change is still awaiting confirmation. Retry sends the same request safely."
    default: return "The change could not be confirmed. Check the catalog and the change history before trying again."
  }
}
